import React from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import Form from './components/Form';
import LegalMentions from './components/LegalMentions';
import NotFoundPage from './components/NotFoundPage';


const App = () => {
    return (
        <BrowserRouter>
            <React.StrictMode>
                <Routes>
                    <Route path="/" element={<Form/>}/>
                    <Route path="/mentions-legales" Component={LegalMentions}/>
                    <Route path="*" element={<NotFoundPage/>}/>
                </Routes>
            </React.StrictMode>
        </BrowserRouter>
    );
};

export default App;
